module.exports = __webpack_public_path__ + "static/Chicory4-db16d079cfefb9d7699fe3fc17d3ef1f.webp";